'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgCommentConvoFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M18.5 7v9.5h-6.33L9.23 20h3.8l1.68 2H17v-2h6V7h-4.5Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M17 15V2H1v13h6v3h1.95l2.52-3H17Z" })
);

module.exports = SvgCommentConvoFill;
//# sourceMappingURL=CommentConvoFill.cjs.js.map
